module.exports = __webpack_public_path__ + "static/media/trainer3.a85bb26a.jpeg";